import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { COOKIE_KEY_NAME, PAGE_ROUTE_PATH } from '@/constants';
import { useInternalRedirect } from '@/features/redirect';
import { useLoginUserInfo } from '@/hooks/useLoginUserInfo';
import { findCookieValue } from '@/utils/cookie';
import { isMobile } from '@/utils/device';

/**
 * 認証エラー画面 hooks
 *
 * @returns
 */
export const useAuthError = () => {
  const navigate = useNavigate();
  const { isSerialPlan } = useLoginUserInfo();
  const { internalRedirectToWelcome } = useInternalRedirect();

  /**
   * ログイン済かどうかを判定
   *
   * @returns true: ログイン済 / false: 未ログイン
   */
  const isLogin = (): boolean => {
    if (findCookieValue(COOKIE_KEY_NAME.PTBR_TOKEN)) {
      return true;
    }

    return false;
  };

  /**
   * [再ログインする]ボタンがクリックされた場合の処理
   */
  const clickLoginAgainButton = useCallback(() => {
    // 未ログインの場合
    if (!isLogin()) {
      if (isMobile()) {
        // 利用方法選択画面に遷移(同一タブ内)
        navigate(PAGE_ROUTE_PATH.SELECT_USAGE);

        return;
      }
      // ログイン画面に遷移(同一タブ内)
      internalRedirectToWelcome();

      return;
    }

    if (isSerialPlan) {
      // シリアルで利用中の場合は、ホーム画面に遷移(同一タブ内)
      navigate(PAGE_ROUTE_PATH.HOME);

      return;
    }

    // PTIDで利用中の場合は、ようこそ画面に遷移(同一タブ内)
    internalRedirectToWelcome();
  }, [isSerialPlan, internalRedirectToWelcome, navigate]);

  return {
    clickLoginAgainButton,
  };
};
